// extracted by mini-css-extract-plugin
export var breadcrumb = "_1n-3";
export var breadcrumbArrow = "_1n-4";
export var breadcrumbs = "_1n-0";
export var link = "_1n-5";
export var sm = "_1n-1";
export var xs = "_1n-2";